import type { FaireProductEntity } from "../../entity_types/product";

export const p_dszk99fapg: FaireProductEntity = {
  token: "p_dszk99fapg",
  type: "product",
  name: "Fish Soap \u2013 Handmade in Minnesota",
  brandName: "Northcast LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/739da3f3ccca788d8225f8cfe184fbd4992767b734195b10dec67f4b6147559d.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/78e7c77052427f2524244ba3d181bf549c5ff29b487ee650ca6e0e64d897ccca.png",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
